export function clean(content) {
  return content.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}